<template>
	<div class="w-full" style="overflow: auto" v-if="!$props.isEdit">
		<!-- Your HTML content goes here -->
		<div v-if="isLoading">
			<div class="mt-10">
				{{ this.loadingMessage }}
			</div>
			<vs-progress indeterminate color="primary">primary</vs-progress>
		</div>
		<div class="flex mt-5" v-else>
			<div>
				{{ newProspects.keywordList.length }} mots-clés selectionnés -
				{{ selectedUrls.length }} urls selectionnées
				<div class="flex justify-between items-start">
					<div class="flex space-x-3 mt-3">
						<!-- Sliding Input with Transition -->
						<transition name="slide-left">
							<div v-if="showInput">
								<vs-input v-model="newInputUrl" />
							</div>
						</transition>
						<!-- Button -->
						<vs-button @click="toggleInput">
							{{ showInput ? "Enregister" : "Url +" }}
						</vs-button>
					</div>
					<div class="flex ml-20 items-start">
						<vs-button @click="exportUrls()">Exporter</vs-button>
					</div>
				</div>
				<!-- <div
					class="mt-5"
					style="max-height: 50vh; overflow: auto"
					ref="keywordsContainerRef"
				> -->

				<div class="table-container" ref="keywordsContainerRef">
					<vs-table
						:data="crossoverUrls"
						pagination
						max-items="500"
						search
						multiple
						class="w-full"
						ref="refKeywordsIdeasTable"
						:key="prospectsTableKey"
						v-model="selectedUrls"
						noDataText="Aucun(e) mots-clés."
					>
						<template slot="header">
							<div class="flex space-x-3 items-center">
								<h3>Urls</h3>
								<span>{{ selectedUrls.length }} / 50</span>
							</div>
						</template>
						<template slot="thead">
							<vs-th
								class="th-sticky"
								style="pointer-events: auto"
								sort-key="domain"
								>URLs</vs-th
							>
							<!-- <vs-th
								class="th-sticky"
								style="pointer-events: auto"
								sort-key="etv"
								>Traffic</vs-th
							>
							<vs-th
								class="th-sticky"
								style="pointer-events: auto"
								sort-key="refDomains"
								>Ref domains</vs-th
							> -->
							<vs-th
								class="th-sticky"
								style="pointer-events: auto"
								sort-key="uniqueCount"
								>Presence</vs-th
							>
							<vs-th
								v-for="(keyword, index) in keywordsHeader"
								class="th-sticky"
								:key="index"
							>
								{{ keywordsHeader[index] }}
							</vs-th>
							<!-- <vs-th style="pointer-events: auto" sort-key=""></vs-th> -->
						</template>

						<template slot-scope="{ data }">
							<vs-tr
								:data="data[indextr]"
								:key="indextr"
								v-for="(tr, indextr) in data"
							>
								<vs-td :data="data[indextr].domain" :key="data[indextr].domain"
									><a
										target="_blank"
										:href="'https://' + tr.domain"
										@click.stop="e.stopPropagation()"
									>
										<span class="m-0 cursor-pointer">
											{{ tr.domain }}
										</span>
									</a></vs-td
								>
								<!-- <vs-td
									class="text-right"
									:data="data[indextr].domain"
									:key="data[indextr].domain"
									>{{ formatNumber(tr.etv) }}
								</vs-td>
								<vs-td
									class="text-right"
									:data="data[indextr].domain"
									:key="data[indextr].domain"
									>{{ formatNumber(tr.refDomains) }}
								</vs-td> -->
								<vs-td
									:data="data[indextr].uniqueCount"
									class="text-right"
									:key="data[indextr].uniqueCount"
									>{{ data[indextr].uniqueCount }} (
									{{
										data[indextr].uniqueCount
											? (
													(data[indextr].uniqueCount /
														newProspects.keywordList.length) *
													100
											  ).toFixed(0)
											: 0
									}}%)</vs-td
								>
								<vs-td
									v-for="(keyword, idx) in keywordsHeader"
									:key="keyword"
									class="text-right"
								>
									<span v-if="getOccurrenceForKeyword(tr.occurrences, keyword)">
										<AscColorChipRenderer
											:value="
												getOccurrenceForKeyword(tr.occurrences, keyword)
													.position
											"
										/>
									</span>
									<span v-else>-</span>
									<!-- Display value from occurrences, or '-' if no value -->
								</vs-td>
								<!-- <vs-td
								v-for="(keyword, idx) in data[indextr].occurrences"
								:key="keyword"
							>
								{{ keyword.position }}
								<vs-icon
									icon="info"
									size="small"
									color="grey"
									@mouseenter="hoveredIndex = indextr"
									@mouseleave="hoveredIndex = null"
								></vs-icon>

								<div v-if="hoveredIndex == indextr" class="info-box">
									<table>
										<thead>
											<tr>
												<th>Keyword</th>
												<th>Position</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(keyword, idx) in data[indextr].occurrences"
												:key="keyword"
											>
												<td>{{ keyword.keyword }}</td>
												<td>{{ keyword.position }}</td>
											</tr>
										</tbody>
									</table>
								</div> -->
								<!-- </vs-td> -->
							</vs-tr>
						</template>
					</vs-table>
					<!-- Go to Top Button -->
				</div>
				<vs-button v-if="showGoTop" @click="scrollToTop" class="go-top-button">
					⬆ Top
				</vs-button>
			</div>
			<!-- </div> -->
		</div>
	</div>
	<div v-else><UpdateProspectUrlPage :projectId="newProspects.id" /></div>
</template>

<script>
import * as XLSX from "xlsx";
import store from "@/store/store";
import DFS from "../../../entities/DFS";
import utilsMixin from "../../../mixins/utilsMixin";
import AscColorChipRenderer from "../../../components/views/dashboard/prospection/cellRenderer/AscColorChipRenderer.vue";
import UpdateProspectUrlPage from "./UpdateProspectUrlPage.vue";

export default {
	components: {
		AscColorChipRenderer,
		UpdateProspectUrlPage,
	},
	name: "ProspectThirdsPageUrl",
	mixins: [utilsMixin],
	props: {
		isEdit: {
			type: Boolean,
			default: false,
		},
	},
	// Your component's logic goes here
	data() {
		return {
			mainUrl: null,
			defaultSelectChoice: [],
			crossoverUrls: [],
			keywordsHeader: [],
			selectedUrls: [],
			keywordsTableKey: 0,
			isLoading: true,
			loadingPercentage: 0,
			bigButton: true,
			smallButtin: false,
			showButton: true,
			hoveredIndex: null,
			loadingMessage:
				"Chargement des données en cours, cela peut prendre quelques minutes. Merci de ne pas quitter la page.",
			// Key
			prospectsTableKey: 0,
			showInput: false,
			newInputUrl: "",
			showGoTop: true,
		};
	},
	watch: {
		selectedUrls: function (data) {
			if (data.length > 50) {
				// Keep only the first 3 items instead of 50
				this.selectedUrls = data.slice(0, 50);
				// Show notification to the user
				this.$vs.notify({
					title: "Selection limitée",
					text: "Vous ne pouvez sélectionner que 50 URLs maximum.",
					color: "warning",
					position: "top-right",
				});
			} else {
				this.$store.dispatch("setNewProspects", {
					...this.newProspects,
					selectedUrls: data,
				});
			}
		},
		defaultSelectChoice: function (data) {
			this.selectedUrls = data;
		},
		isLoading: function (data) {
			this.makeSticky();
		},
	},
	computed: {
		// Your component's computed properties go here
		newProspects() {
			return store.state.newProspects;
		},
		oldProspects() {
			return store.state.oldProspects;
		},
	},
	mounted() {
		this.makeSticky();
		this.$refs.tableContainer.addEventListener(
			"scroll",
			this.checkScrollPosition
		);
		// this.$nextTick(() => {
		// 	const tableContainer =
		// 		this.$refs.table.$el.querySelector(".vs-table__content");
		// 	if (tableContainer) {
		// 		tableContainer.addEventListener("scroll", this.handleScroll);
		// 	}
		// });
	},
	updated() {
		this.makeSticky();
	},

	created() {
		this.fetchCrossoverUrlsForKeywords();
		// Code to run when the component is created
		console.log("Running ProspectThirdsPageUrl created");
		if (this.$props.isEdit) {
			// need to add old keywords to the choosen keywords to display with new keywords
			this.checkAddOldProspectsUrl();
			// this.keywordsTableKey++;
		}
	},
	beforeDestroy() {
		// Code to run when the component is destroyed
		this.crossoverUrls = [];
		this.selectedUrls = [];
	},

	methods: {
		handleSelectionChange(selectedItems) {
			// If trying to select more than 3 items instead of 50
			if (selectedItems.length > 3) {
				// Keep only the first 3 items
				this.selectedUrls = selectedItems.slice(0, 3);
				this.prospectsTableKey++;
				// Show notification to the user
				this.$vs.notify({
					title: "Selection limitée",
					text: "Vous ne pouvez sélectionner que 3 URLs maximum.",
					color: "warning",
					position: "top-right",
				});
			} else {
				// Update normally if under the limit
				this.selectedUrls = selectedItems;

				// Update the store
				this.$store.dispatch("setNewProspects", {
					...this.newProspects,
					selectedUrls: this.selectedUrls,
				});
			}
		},
		formatNumber(num) {
			try {
				num = Math.round(num);
				if (num >= 1000000) {
					return (num / 1000000).toFixed(2) + "M"; // Convert to millions
				} else if (num >= 1000) {
					return (num / 1000).toFixed(2) + "K"; // Convert to thousands
				}
				return num.toString(); // Return as is if less than 1K
			} catch (e) {
				// console.log("Error in formatNumber", e);
				return "-";
			}
		},

		scrollToTop() {
			const tableContainer = this.$refs.keywordsContainerRef;
			tableContainer.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		},
		// Listen for the scroll event to show the button
		checkScrollPosition() {
			const tableContainer = this.$refs.keywordsContainerRef;
			if (tableContainer.scrollTop > 200) {
				// Change 200 based on when you want the button to appear
				this.showGoTop = true;
			} else {
				this.showGoTop = false;
			}
		},
		makeSticky() {
			setTimeout(() => {
				const checkColumn = document.querySelector(".td-check");
				if (checkColumn) {
					checkColumn.classList.add("th-sticky");
				}
			}, 1000); // Adjust time based on data load delay
		},
		/** Export Urls */
		exportUrls() {
			// Prepare the data to export
			const exportData = this.crossoverUrls.map((row) => {
				const rowData = {
					domain: row.domain,
					uniqueCount: row.uniqueCount,
				};

				this.keywordsHeader.forEach((keyword) => {
					const occurrence = this.getOccurrenceForKeyword(
						row.occurrences,
						keyword
					);
					rowData[keyword] = occurrence ? occurrence.position : "-";
				});

				return rowData;
			});

			// Create a worksheet
			const worksheet = XLSX.utils.json_to_sheet(exportData);

			// Create a new workbook
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Prospect List");

			// Export to Excel
			XLSX.writeFile(workbook, "prospect_list.xlsx");
		},
		/**
		 * Get the occurrence object for a keyword
		 * @param {Array} occurrences
		 * @param {String} keyword
		 * @returns {Object}
		 */
		getOccurrenceForKeyword(occurrences, keyword) {
			// Find the object in the occurrences array where the keyword matches
			try {
				let found = occurrences.find((item) => item.keyword === keyword);
				if (!found) return 0;
				return found;
			} catch (e) {
				return 0;
			}
		},
		/**
		 * Toggle the input field
		 */
		toggleInput() {
			if (!this.showInput)
				this.showInput = !this.showInput; // Toggle the visibility of the input
			else {
				if (this.newInputUrl.length > 0) {
					this.crossoverUrls.unshift({
						domain: this.newInputUrl,
					});
					this.newInputUrl = "";
					this.prospectsTableKey++;
				}
			}
		},
		/**
		 * Check if the old prospects are in the new prospects
		 */
		checkAddOldProspectsUrl() {
			let oldChoosedUrls = [];
			this.oldProspects.prospect_list.forEach((ele, index, array) => {
				let foundOldProspectList = this.crossoverUrls.find(
					(value, index, array) =>
						ele.url.replace("https://", "").replace("wwww.", "") ==
						value.domain.replace("https://", "").replace("wwww.", "")
				);
				// add old keywords to the choosen keywords with new data from the keyword list
				if (foundOldProspectList) {
					oldChoosedUrls.push(foundOldProspectList);
				} else {
					// if not found , add anywasy to the keyword list with old data
					this.crossoverUrls.unshift({ domain: ele.url });
					oldChoosedUrls.unshift({ domain: ele.url });
				}
			});
			// Make sure we don't exceed the 3 URL limit when loading old URLs
			this.selectedUrls = oldChoosedUrls.slice(0, 3);
		},

		async onClickCossover() {
			// big Button
			this.isLoading = true;
			this.bigButton = true;
			try {
				this.tooglePropsectLoading(true);
				// this.setLoading(true, "prospect-run-cossover-button-1");
				await this.fetchCrossoverUrlsForKeywords();
			} catch (e) {
				console.log("Error in onClickCossover", e);
			} finally {
				// this.setLoading(false, "prospect-run-cossover-button-1");
				this.isLoading = false;
				this.tooglePropsectLoading(false);
			}
		},
		extractHostname(url) {
			try {
				// Ensure the URL has a protocol
				let fullUrl = url.startsWith("http") ? url : `https://${url}`;
				return new URL(fullUrl).hostname.replace("www.", "");
			} catch (e) {
				console.error("Invalid URL:", url, e);
				return null; // Return null or handle as needed
			}
		},
		/**
		 * Fetch crossover urls for the selected keywords
		 */
		async fetchCrossoverUrlsForKeywords() {
			this.isLoading = true;
			try {
				let response = await DFS.getCrossoverUrlsForKeywords(
					this.newProspects.keywordList,
					this.newProspects.location_code,
					this.newProspects.language_code
				);

				this.crossoverUrls = response.uniqueDomains;
				// this.crossoverUrls.forEach((row) => {
				// 	row.etv = row.traffic.metrics.organic.etv; // Flatten for sorting
				// 	row.refDomains = row.refBacklink.referring_domains; // Flatten for sorting
				// });

				// Check if the main URL is in the crossover URLs
				if (this.newProspects.mainUrl) {
					// Create a new domain entry by default
					let newDomainEntry = {
						id: Date.now(),
						domain: this.newProspects.mainUrl,
						occurrences: this.newProspects.keywordList.map((keyword) => ({
							keyword: keyword,
							position: 0,
							pointUrl: "",
						})),
						uniqueCount: this.newProspects.keywordList.length,
					};
					// Extract the hostname from the main URL
					let inputMainUrl = this.extractHostname(this.newProspects.mainUrl);

					// Find the index of the main URL in the crossover URLs
					let foundUrlIndex = this.crossoverUrls.findIndex(
						(value) =>
							this.extractHostname(value.domain) ==
							this.extractHostname(inputMainUrl)
					);

					// If the main URL is found in the crossover URLs so we donot create a double of same url in the list
					if (foundUrlIndex !== -1) {
						// Store the found URL
						let foundUrl = this.crossoverUrls[foundUrlIndex];

						// Remove it from its original position
						this.crossoverUrls.splice(foundUrlIndex, 1);

						// Insert it at the first position
						this.crossoverUrls.unshift(foundUrl);

						// Optionally set the new domain entry
						newDomainEntry = foundUrl;
					}
					this.defaultSelectChoice = [newDomainEntry];
				}
				this.keywordsHeader = this.newProspects.keywordList;

				// this.selectedUrls.unshift(newDomainEntry);
				// this.clearStoredProspectUrls();
				this.checkAddOldProspectsUrl();
				// this.crossoverUrls = eventData.message;
				this.prospectsTableKey++;
				this.bigButton = false;
				this.tooglePropsectLoading(false);
			} catch (error) {
				console.error("fetchCrossoverUrlsForKeywords", error);
				this.loadingPercentage = 0;
				// this.eventSource.close();

				this.tooglePropsectLoading(false);
				// this.setLoading(false, "prospect-run-cossover-button-1");
			} finally {
				this.isLoading = false;
			}
		},

		/**
		 * Set loading state of the prospects with correspoonds to the last step button
		 * @param {Boolen} isLoading
		 */
		tooglePropsectLoading(isLoading) {
			this.$store.dispatch("setNewProspects", {
				...this.newProspects,
				isLoadingLastStep: isLoading,
			});
		},
		/**
		 * Clear stored prospect urls
		 */
		clearStoredProspectUrls() {
			this.$store.dispatch("setNewProspects", {
				...this.newProspects,
				prospect_list: [],
			});
		},
		// return new Promise((resolve, reject) => {
	},
};
</script>

<style scoped>
.slide-left-enter-active,
.slide-left-leave-active {
	transition: all 0.5s ease;
}
.slide-left-enter,
.slide-left-leave-to {
	transform: translateX(-100%);
	opacity: 0;
}
/* Your component's styles go here */
h1 {
	color: blue;
}
body {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	margin: 0;
	background-color: #1e1e1e;
}
.button-container {
	position: relative;
	display: inline-block;
}

.circular-button {
	width: 100px;
	height: 100px;
	border: 5px solid #08b0b9;
	border-radius: 50%;
	background-color: #08b0b9;
	color: white;
	font-size: 16px;
	font-weight: bold;
	cursor: pointer;
	outline: none;
	position: relative;
	z-index: 10;
	transition: background-color 0.3s, box-shadow 0.3s;
}
.info-box {
	position: absolute;
	background-color: white;
	border: 1px solid #ccc;
	padding: 10px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	/* Adjust the position of the box as needed */
	margin-top: 10px; /* This makes the box appear below the button */
}
.info-box table {
	width: 100%;
	border-collapse: collapse;
}

.info-box th,
.info-box td {
	border-bottom: 1px solid #ccc;
	padding: 5px;
	text-align: left;
}

.info-box th {
	background-color: #f9f9f9;
}
.table-container {
	margin: 10px 0;
	position: relative;
	overflow: auto;
	max-height: 500px; /* Adjust to the desired table container height */
}
.go-top-button {
	position: absolute;
	bottom: 80px;
	right: 20px;
	padding: 15px;
	background-color: #007bff;
	color: white;
	border: none;
	z-index: 100;
	/* border-radius: 50%; */
	cursor: pointer;
	/* font-size: 24px; */
	opacity: 0.7;
	transition: opacity 0.3s ease-in-out;
}

.go-top-button:hover {
	opacity: 1;
}
</style>